import { render, staticRenderFns } from "./CardInpekel.vue?vue&type=template&id=6c5d7293"
import script from "./CardInpekel.vue?vue&type=script&lang=js"
export * from "./CardInpekel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports